import { AboCreditAdjustmentResponse } from "../../api/memberCredits/types";
import { formatCount } from "../../utils/formatCount";
import {
  memberCreditsStrings as S,
  formatMessage,
} from "./MemberCreditsTab.strings";

/** A signed change: "+5", "-3", "0". */
export const formatSignedCredits = (value: number): string =>
  `${value > 0 ? "+" : ""}${formatCount(value)}`;

/** "1 credit" / "5 credits" (the sign is dropped). */
export const formatCredits = (count: number): string =>
  formatMessage(
    Math.abs(count) === 1 ? S.adjust.credits.one : S.adjust.credits.many,
    { count: formatCount(Math.abs(count)) }
  );

/** The message for a successful (or replayed) adjustment. */
export const adjustmentResultMessage = (
  result: AboCreditAdjustmentResponse
): string => {
  const balance = formatCount(result.balanceAfter);
  if (result.replayed) {
    return formatMessage(S.adjust.result.replayed, { balance });
  }
  if (result.clamped) {
    return result.applied === 0
      ? formatMessage(S.adjust.result.clampedToZero, { balance })
      : formatMessage(S.adjust.result.clamped, {
          applied: formatCount(Math.abs(result.applied)),
          requested: formatCount(Math.abs(result.requested)),
          balance,
        });
  }
  return formatMessage(
    result.applied < 0 ? S.adjust.result.removed : S.adjust.result.added,
    { amount: formatCredits(result.applied), balance }
  );
};
